import { render } from "./GreenButton.vue?vue&type=template&id=293c2a64&scoped=true"
import script from "./GreenButton.vue?vue&type=script&lang=js"
export * from "./GreenButton.vue?vue&type=script&lang=js"

import "./GreenButton.vue?vue&type=style&index=0&id=293c2a64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-293c2a64"]])

export default __exports__